import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CountryNames } from 'src/app/interfaces/apiresponses';
import { RestService } from 'src/app/services/rest/rest.service';

@Component({
  selector: 'app-global-data',
  templateUrl: './global-data.component.html',
  styleUrls: ['./global-data.component.scss']
})
export class GlobalDataComponent implements OnInit {
  @Output() OnCountryListReady = new EventEmitter()
  CountryList: CountryNames | undefined

  constructor(private restService: RestService){
    
  }

  ngOnInit(): void {
    this.loadCountryNames()
  }

  loadCountryNames(){
    this.restService.getCountryList().subscribe({
      next : (v: CountryNames) => {
        this.CountryList = v
        this.OnCountryListReady.emit({success: true, data: this.CountryList})
      },
      error : (e) => {
        this.OnCountryListReady.emit({success: false, data: this.CountryList})
      }
    })
  }

}
